import { ChangeDetectionStrategy, Component, input, linkedSignal, output } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { TranslocoDecimalPipe } from '@jsverse/transloco-locale';
import {
  INotificationRecipientModel,
  IOrderSignerModel,
  OrderParticipantTab,
  TabDefinition,
} from '@dss-libs/portal/type/portal-types';
import { AutoHideScrollbarDirective } from '@dss-libs/shared/ui/common-directives';
import { InitialsPipe } from '@dss-libs/shared/ui/common-pipes';
import { SignerCardComponent } from '../signer-card/signer-card.component';
import { ChipComponent } from '@dss-libs/shared/ui/common-components';

@Component({
  selector: 'dss-libs-feature-recipients-panel',
  imports: [
    TranslocoDirective,
    TranslocoDecimalPipe,
    AutoHideScrollbarDirective,
    SignerCardComponent,
    InitialsPipe,
    ChipComponent,
  ],
  templateUrl: './recipients-panel.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RecipientsPanelComponent {
  readonly signers = input.required<IOrderSignerModel[]>();
  readonly reviewers = input.required<IOrderSignerModel[]>();
  readonly receivers = input.required<INotificationRecipientModel[]>();
  readonly tabs = input.required<TabDefinition[]>();
  readonly expiryDate = input.required<string>();
  readonly daysRemaining = input<number | null>(null);
  readonly sendingReminderForId = input<string | null>(null);
  readonly canSendReminder = input(true);

  readonly sendReminder = output<string>();

  protected readonly DetailsTab = OrderParticipantTab;
  protected readonly activeTab = linkedSignal<OrderParticipantTab>(
    () => this.tabs()[0]?.key ?? OrderParticipantTab.Signers
  );
}
